module.exports = __webpack_public_path__ + "img/function_img1_fan.b9c2e24d.png";